import type { PortalClient } from "./types";

const API_URL = import.meta.env.VITE_API_URL ?? "";

export async function getMe(): Promise<PortalClient | null> {
  const response = await fetch(`${API_URL}/api/me`, { credentials: "include" });
  if (response.status === 401) return null;
  if (!response.ok) throw new Error("Unable to load your portal right now.");
  const body = await response.json() as { client: PortalClient };
  return body.client;
}

export async function devLogin(email: string, code: string): Promise<void> {
  const response = await fetch(`${API_URL}/api/auth/dev-login`, {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email, code }),
  });
  if (!response.ok) throw new Error("The email or access code was not accepted.");
}

export async function logout(): Promise<void> {
  await fetch(`${API_URL}/api/auth/logout`, { method: "POST", credentials: "include" });
}
